import { Stack, Typography, useTheme } from "@mui/material";
import ScoutIcon from "components/ScoutIcon";

import { ScoutInput } from "./ScoutInput";

export function NewChat({
  onSubmit,
  isSending,
}: {
  onSubmit: (text: string) => Promise<void>;
  isSending: boolean;
}) {
  const theme = useTheme();
  return (
    <Stack
      sx={{
        flex: 1,
        width: "100%",
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: 2,
        marginTop: 5,
        gap: 5,
      }}
    >
      <ScoutIcon sx={{ color: theme.palette.encampBlue.main, width: 80, height: 80 }} />
      <Typography variant="h6" textAlign="center">
        Hey there! I'm Scout, your Encamp guide. How can I help you today?
      </Typography>

      <ScoutInput
        onSubmit={onSubmit}
        isSending={isSending}
        placeholder="Check regulations, help me understand compliance requirements..."
      />
    </Stack>
  );
}
